import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGetIndividualReportPdfQuery } from './SurveyResponse/queries/getIndividualReportPdfQuery';
import { Response } from '../queries/getQuizQuery';

type Props = {
  readonly response: Response['quiz']['responses'][number];
};

export default function DownloadReport({ response }: Props) {
  const [fetchReportUrl, { loading }] =
    useGetIndividualReportPdfQuery({
      variables: { responseId: response.id },
    });

  const handleGeneratePdf = async () => {
    if (loading) return;
    const reportResonse = await fetchReportUrl();
    const reportFileUrl =
      await reportResonse?.data?.getIndividualReportPdf?.reportUrl;
    window.open(reportFileUrl, '_blank');
  };

  return (
    <div>
      {response.reportUrl ? (
        <a
          href={response.reportUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="px-3 py-3  rounded shadow hover:bg-gray-100 text-gray-700"
        >
          <FontAwesomeIcon icon="download" />
          <span>Download Report</span>
        </a>
      ) : loading ? (
        <div>Loading...</div>
      ) : (
        <button
          onClick={handleGeneratePdf}
          className="px-3 py-3 rounded shadow hover:bg-gray-100 text-gray-700"
        >
          <FontAwesomeIcon icon="file-pdf" />
          <span>Download Report</span>
        </button>
      )}
    </div>
  );
}
